import { DocumentType } from '@dc-shared-web/hooks/api/office/types'
import { AxiosInstance } from 'axios'

export const fetchDocumentTypesByOffice = async (
  apiClient: AxiosInstance,
  params: {
    officeUUID: string
  }
) => {
  const { data } = await apiClient.get<DocumentType[]>(
    `/api/office/${params.officeUUID}/document-types`
  )

  return data
}
